
export const Resourse = {
    ResSelector: '--انتخاب نمایید--',
    ResSaveButton: 'ذخیره',
    ResCancelButton: 'انصراف',
    ResRowNumberTitle: '#',
    ResSelectorOption: { id: '', name: '--انتخاب نمایید--' },
    OrganizationName: ' وزارت ارتباطات و فناوری اطلاعات',
    SystemName: 'سامانه ارسال صورتحساب مودیان',
    editTitle: 'ویرایش',
    ResEditDeleteCellWidth:'75px',
    deleteTitle: 'حذف',
    ResEditDeleteCellWidth: '75px',
    historyTitle: 'سوابق',
    showTitle: 'مشاهده',
    ResYesButton: 'بله',
    ResNoButton: 'خیر',
    NoRecordsTxt: 'رکوردی جهت نمایش وجود ندارد!',
    InValidTxt: 'پر کردن این فیلد الزامی می باشد!',
    InValidTxtMin3: 'پر کردن این فیلد الزامی می باشد (حداقل سه کاراکتر)',
    InValidTxtMin2: 'پر کردن این فیلد الزامی می باشد (حداقل دو کاراکتر)',
    NewRecord: 'ثبت ',
    FormsMessage: '* پس از ثبت اطلاعات در فیلد ها و تکمیل اطلاعات ، برای ثبت رکورد جدید ، دکمه ثبت را بزنید',
    ResNextLevel: 'ثبت و مرحله بعد',
    ResBeforeLevel: 'مرحله قبل',
    ResDeleteLevel: 'حذف کل اطلاعات این مرحله',
    AllHistory:'نمایش سوابق کل عملیات',
    PassFormat: 'رمز عبور باید حداقل شش کاراکتر و حداقل شامل یک کاراکتر [a-z] ، یک کاراکتر [A-Z] ، یک رقم و یک کاراکتر [$,#,!] باشد.(به عنوان مثال : Aa#123)',
    ResEditDate: 'تاریخ ویرایش',
    ResUserName: 'نام کاربر',
}